import React, {Component} from 'react';

import '../sass/cgu.scss';

import Footer from '../components/Footer';
import CguText from '../components/cgu/CguText';

import {getLocale} from 'l10n';

class Cgu extends Component {

    constructor(props) {
        super(props);

        this.state = {};

    }

    render() {

        return (
            <div id="wrapper" className="cgu-wrapper">
                <CguText lang={getLocale()} />
            </div>
        )
    }
}

export default Cgu;



// WEBPACK FOOTER //
// ./src/containers/Cgu.js